import React from "react";
import ProfilePic from "../Assets/san-image.png";
import { AiFillStar } from "react-icons/ai";

const Testimonial = () => {
  return (
    <div className="work-section-wrapper">
      <div className="work-section-top">
        <p className="primary-subheading">Testimonial</p>
        <h1 className="primary-heading">What They Are Saying</h1>
        <p className="primary-text">
        "The food is always fresh, flavorful, and made to perfection! The delivery was super fast, and my order was still hot when it arrived. Highly recommend!"
        </p>
        
        </div>
      <div className="testimonial-section-bottom">
        <img src={ProfilePic} alt="" />
        <p>
        "The Foodie app makes ordering so easy! I can customize my meal just the way I like it, and the delivery is always on time. My go-to place for a quick and delicious dinner!"
        </p>
        <div className="testimonials-stars-container">
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
        </div>
        <h2>Nivetha Thomas</h2>
      </div>
    </div>
  );
};

export default Testimonial;